var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreasing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0L0 3.69231L0.816667 4.55385L2.91667 2.33846V8H4.08333V2.33846L6.18333 4.55385L7 3.69231L3.5 0Z",
    fill: "#FF8E02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V6H11V7H9ZM9 4V3H13V4H9ZM9 1V0H15V1H9Z",
    fill: "#FF8E02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasing);
export default __webpack_public_path__ + "static/media/Increasing.7935a303117c598f681e0ec9d155f18f.svg";
export { ForwardRef as ReactComponent };